module.exports = __webpack_public_path__ + "img/jiuhong.c781e784.png";